import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";

import avatar from "./../../assets/images/av2.png";
import { withRouter } from "react-router-dom";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./style.module.scss";

import dashboard from "./../../assets/icons/dashboard.svg";
import account from "./../../assets/icons/user.svg";
import atm from "./../../assets/icons/atm.svg";
import transaction from "./../../assets/icons/transaction.svg";
import logout from "./../../assets/icons/logout.svg";

class Index extends Component {
    logout() {
        Cookies.remove("_lab__topup");
    }

    render() {
        return (
            <div
                className={[
                    styles.sidebar,
                    this.props.visible
                        ? styles.visibleNav
                        : styles.inVisibleNav,
                ].join(" ")}
            >
                <nav>
                    <ul>
                        <li className={styles.preview}>
                            <img src={avatar} alt="avatar" />
                            <div>
                                <h4>
                                    {this.props.userInfo.userName.toUpperCase()}
                                </h4>
                                <p
                                    style={{
                                        textAlign: "center",
                                        backgroundColor: "#3598DB",
                                        borderRadius: "25px",
                                        color: "#FFFFFF",
                                        fontWeight: ".5em",
                                    }}
                                >
                                    {this.props.userInfo.accountType
                                        ? this.props.userInfo.accountType.toUpperCase()
                                        : null}
                                </p>
                            </div>
                        </li>
                        <NavLink
                            to="/user-profile"
                            exact
                            activeClassName={styles.active}
                        >
                            <li>
                                <img src={account} alt="zero" width="30" />
                                USER PROFILE
                            </li>
                        </NavLink>
                        <NavLink
                            to="/dashboard"
                            exact
                            activeClassName={styles.active}
                        >
                            <li>
                                <img src={dashboard} alt="zero" width="30" />
                                DASHBOARD
                            </li>
                        </NavLink>
                        <NavLink
                            to="/withdraw"
                            exact
                            activeClassName={styles.active}
                        >
                            <li>
                                <img src={atm} alt="zero" width="30" />
                                WITHDRAW BALANCE
                            </li>
                        </NavLink>
                        <NavLink
                            to="/history"
                            exact
                            activeClassName={styles.active}
                        >
                            <li>
                                <img src={transaction} alt="zero" width="30" />
                                TRANSACTIONS
                            </li>
                        </NavLink>
                        <NavLink
                            to="/login"
                            exact
                            activeClassName={styles.active}
                            onClick={this.logout}
                        >
                            <li>
                                <img src={logout} alt="zero" width="30" />
                                LOGOUT
                            </li>
                        </NavLink>
                    </ul>
                </nav>
            </div>
        );
    }
}

Index.propTypes = {
    userInfo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    userInfo: state.user.userInfo,
});

export default connect(mapStateToProps, {})(withRouter(Index));
